import type { BestellStatus, BestellungIntern } from "@repo/shared";

export const STATUS: { wert: BestellStatus; label: string }[] = [
  { wert: "offen", label: "Offen" },
  { wert: "bestaetigt", label: "Bestätigt" },
  { wert: "bestellt", label: "Bestellt" },
  { wert: "in_produktion", label: "In Produktion" },
  { wert: "versendet", label: "Versendet" },
  { wert: "storniert", label: "Storniert" },
];

export const statusLabel = (status: BestellStatus) =>
  STATUS.find((s) => s.wert === status)?.label ?? status;

/** Datum oder Zeitpunkt als „01.10.2026“. */
export function datum(wert: string | null): string {
  if (!wert) return "–";
  // Reine Kalenderdaten (JJJJ-MM-TT) nicht durch die Zeitzone schieben.
  const d = /^\d{4}-\d{2}-\d{2}$/.test(wert) ? new Date(`${wert}T12:00:00`) : new Date(wert);
  return d.toLocaleDateString("de-DE");
}

export function zeitpunkt(wert: string): string {
  return new Date(wert).toLocaleString("de-DE", { dateStyle: "short", timeStyle: "short" });
}

/** Bei wie vielen Herstellern schon bestellt ist. */
export function fortschritt(b: BestellungIntern): { bestellt: number; gesamt: number } {
  return {
    bestellt: b.hersteller.filter((h) => h.bestelltAm).length,
    gesamt: b.hersteller.length,
  };
}

export function margeProzent(gewinnCents: number, vkNettoCents: number): string {
  if (vkNettoCents <= 0) return "–";
  return `${((gewinnCents / vkNettoCents) * 100).toLocaleString("de-DE", { maximumFractionDigits: 1 })} %`;
}
